import React, { useRef } from 'react';
import { useCssInJs, wrapReactionHook } from "../../hooks";
import { Button, Table } from 'antd';
import { genBenchmarkBrandsStyle } from "./styles";
import { useField } from '@formily/react';
import cx from 'classnames';
export var BenchmarkBrands = wrapReactionHook(function (props) {
  var field = useField();
  var prefix = 'benchmark-brands';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genBenchmarkBrandsStyle
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var columns = useRef([{
    title: '品牌名称',
    dataIndex: 'name'
  }, {
    title: '品牌营业额',
    dataIndex: 'turnover'
  }]).current;
  var readOnly = field.readOnly;
  return wrapSSR( /*#__PURE__*/React.createElement("div", {
    className: cx(hashId, prefix)
  }, /*#__PURE__*/React.createElement(Table, {
    columns: columns
  }), readOnly ? null : /*#__PURE__*/React.createElement(Button, {
    block: true,
    type: "dashed",
    className: cx(hashId, 'append')
  }, "\u6DFB\u52A0\u5BF9\u6807\u54C1\u724C")));
});